import { DepotSearchDialog } from "./components/DepotSearchDialog";

export default DepotSearchDialog;